// Tariff management route map.
//
//   /tariffs              the catalogue (the pricing module's admin page, embedded)
//   /tariffs/approvals    the plans waiting for a tariff manager's decision
//   /tariffs/performance  how the plans are selling
//   /tariffs/users        who may decide — admins only
//
// Four routes, ONE page: `TariffManagementPage` is the shared chrome (topbar
// and the tab strip) and the `view` prop picks what renders under it. They
// are separate routes rather than a `?tab=` so deep links, refresh and
// back/forward keep working and each view keeps its own data and paging.
// `services/tariffViews.service.ts` holds the tab targets and is tested
// against this table, so a tab can never point at a path declared here and
// then removed.
//
// The role guard is enforced by `CrmShell`'s `ROUTE_ACCESS` on the `/tariffs`
// and `/tariffs/users` prefixes, which also decides who sees the rail entry
// and the Users tab; the managers page re-checks and renders `AccessDenied`.

import { lazy } from 'react';
import type { RouteObject } from 'react-router-dom';

const TariffManagementPage = lazy(() =>
  import('./pages/TariffManagementPage').then((m) => ({ default: m.TariffManagementPage })),
);

export const tariffsRoutes: RouteObject[] = [
  { path: '/tariffs', element: <TariffManagementPage view="plans" /> },
  { path: '/tariffs/approvals', element: <TariffManagementPage view="approvals" /> },
  { path: '/tariffs/performance', element: <TariffManagementPage view="performance" /> },
  { path: '/tariffs/users', element: <TariffManagementPage view="users" /> },
];
